import { createSlice } from "@reduxjs/toolkit";
import { FilterStateNsuRegister } from "./types";

const INITIAL_STATE: FilterStateNsuRegister = {
  filters: {
    search: "",
    meta: {
      page: 1,
    },
  },
};

const NsuRegisterFilterSlice = createSlice({
  name: "NsuRegisterFilter",
  initialState: INITIAL_STATE,
  reducers: {
    setFilter(state, action) {
      state.filters[action.payload.key] = action.payload.value;
    },
  },
});

export const { setFilter } = NsuRegisterFilterSlice.actions;
export default NsuRegisterFilterSlice.reducer;
